import {
  APPROVED,
  PENDING,
  REJECTED,
  MORE_INFO,
  DELETED,
  ERROR,
  PROCESSING,
} from './constants';

// pending
export const getColor = (id) => {
  switch (id) {
    case APPROVED:
      return 'success';
    case REJECTED:
    case ERROR:
      return 'error';
    case MORE_INFO:
      return 'info';
    case PROCESSING:
      return 'pending';
    case PENDING:
      return 'warning';
    case DELETED:
      return 'error';
  }
};
